enum PublishOptions {
  WITHIN_48_HOURS = 'within48Hours',
  CHOOSE_A_DATE = 'chooseADate',
}

export { PublishOptions }
